var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35547 5.75L6.72656 6.37891L2.35156 10.7539L1.75 11.3828L0.492188 10.125L1.12109 9.52344L4.86719 5.75L1.12109 2.00391L0.492188 1.375L1.75 0.144531L2.35156 0.773438L6.72656 5.14844L7.35547 5.75Z",
    fill: "#BCD4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowProject);
export default __webpack_public_path__ + "static/media/arrow_project.2ec78b0be72c3862c9edc414762e6cd5.svg";
export { ForwardRef as ReactComponent };